import styled from 'styled-components';
import { HSSelect } from './HSSelect';

export const FilterBarContainer = styled.div`
  margin-left: 15px;
  /* Lines up with the header search box, which is offset by 12px. */
  margin-top: 12px;
`;

const CHECKBOX_COLOUR = '#005c98';
const OPTION_TEXT_COLOUR = '#113e57';
const HIGHLIGHT_COLOUR = 'rgba(63, 169, 245, 1)';

// Field look comes from HSSelect; these are the filter-specific additions.
export const FilterSelect = styled(HSSelect)`
  min-width: 200px;

  /* Same 30px slot as the search box's icon so the two labels line up. */
  .ant-select-prefix {
    width: 30px;
  }

  .filter-icon {
    width: 24px;
    height: 24px;
  }

  &.ant-select-multiple .ant-select-selection-item {
    background: none;
    border: none;
    padding-inline: 0;
  }
`;

export const FilterPopup = styled.div`
  min-width: ${({ $hasButtons }) => ($hasButtons ? '400px' : 'auto')};
  padding: 0;
  background: #ffffff;
  border-radius: 13px;

  .ant-select-item-group {
    min-height: 0;
    margin: 4px 0;
    padding: 0 16px 4px;
    border-bottom: 1px solid #c9c9c9;
    color: #808080;
    font-size: 14px;
    font-weight: 400;
  }

  .ant-select-item-option {
    display: flex;
    align-items: center;
    min-height: 36px;
    margin-bottom: 2px;
    padding: 6px 16px;
    border-radius: 7px;
  }

  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
    background: ${HIGHLIGHT_COLOUR};
  }

  .ant-checkbox-wrapper {
    align-items: center;

    span {
      color: ${OPTION_TEXT_COLOUR};
      font-size: 16px;
      font-weight: 400;
      cursor: pointer;
    }
  }

  .ant-checkbox .ant-checkbox-inner {
    width: 22px;
    height: 22px;
  }

  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${CHECKBOX_COLOUR};
    border-color: ${CHECKBOX_COLOUR};
  }

  .ant-checkbox .ant-checkbox-inner::after {
    width: 6px;
    height: 11px;
    top: 45%;
  }
`;

export const FilterActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  margin-top: 6px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-top: 1px solid #c9c9c9;
  white-space: nowrap;

  .new-custom-button {
    width: 113px;
    height: 32px;
    border-color: #ccdce4 !important;
  }

  .cancel .new-button-text {
    color: #4e758e;
    font-weight: 400;
  }

  .primary .new-button-text {
    color: #003252;
    font-weight: 400;
  }
`;

export const ResetFiltersButton = styled.button.attrs({ type: 'button' })`
  padding: 0;
  border: none;
  background: none;
  color: #4e758e;
  cursor: pointer;
  font-feature-settings: 'salt' on;
  font-size: 16px;
  font-weight: 700;
  line-height: 120%;

  &:focus-visible {
    outline: 2px solid #113e57;
    outline-offset: 2px;
  }
`;
